class IngredientsLookbookIcon extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('mouseenter', this.init.bind(this));
    this.addEventListener('mouseenter', this.handleHover.bind(this));
    this.addEventListener('mouseleave', this.handleMouseOut.bind(this));
    
    // Get the related card using the data-id
    this.ingredientId = this.dataset.id;
    this.relatedCard = document.querySelector(`.ingredient-card[data-id="${this.ingredientId}"]`);
    
    // Store product element reference
    this.product = this.querySelector('.ingredient-lookbook__product');
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.init.bind(this));
    this.removeEventListener('mouseenter', this.handleHover.bind(this));
    this.removeEventListener('mouseleave', this.handleMouseOut.bind(this));
  }

  handleHover() {
    if (this.relatedCard) {
      this.relatedCard.classList.add('is-active');
    }
    if (this.product) {
      this.init(); // Ensure position is calculated
      this.product.style.display = 'flex';
      this.classList.add('is-active'); // Add active class to the annotation
    }
  }

  handleMouseOut() {
    if (this.relatedCard) {
      this.relatedCard.classList.remove('is-active');
    }
    if (this.product) {
      this.product.style.display = 'none';
      this.classList.remove('is-active'); // Remove active class from the annotation
    }
  }

  init() {
    if (!this.product) return;

    const container = this.closest('.ingredients-bundle__image');
    if (!container) return;

    const containerRect = container.getBoundingClientRect();
    const iconRect = this.getBoundingClientRect();

    const offsetX = iconRect.left - containerRect.left;
    const offsetY = iconRect.top - containerRect.top;

    const productWidth = this.product.offsetWidth || 200; // Use default width if not yet rendered
    const containerWidth = container.clientWidth;

    // Position horizontally
    if (offsetX > productWidth) {
      this.product.style.left = 'auto';
      this.product.style.right = containerWidth - offsetX < 15 ? 'calc(-100% + 2rem)' : '-100%';
    } else {
      this.product.style.right = 'auto';
      if (containerWidth - offsetX > productWidth) {
        this.product.style.left = offsetX < 15 ? 'calc(-100% + 2rem)' : '-100%';
      } else {
        this.product.style.left = `${containerWidth - productWidth - offsetX}px`;
      }
    }

    // Position vertically
    if (offsetY > this.product.offsetHeight) {
      this.product.style.top = 'auto';
      this.product.style.bottom = '100%';
    } else {
      this.product.style.bottom = 'auto';
      this.product.style.top = '100%';
    }
  }
}

// Add card hover functionality
class IngredientCard extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('mouseenter', this.handleHover.bind(this));
    this.addEventListener('mouseleave', this.handleMouseOut.bind(this));
    
    // Get the related hotspot using the data-id
    this.ingredientId = this.dataset.id;
    this.relatedHotspot = document.querySelector(`ingredients-lookbook-icon[data-id="${this.ingredientId}"]`);
  }

  handleHover() {
    if (this.relatedHotspot) {
      this.relatedHotspot.classList.add('is-active');
      this.relatedHotspot.dispatchEvent(new Event('mouseenter')); // Trigger hotspot hover
    }
  }

  handleMouseOut() {
    if (this.relatedHotspot) {
      this.relatedHotspot.classList.remove('is-active');
      this.relatedHotspot.dispatchEvent(new Event('mouseleave')); // Trigger hotspot mouseout
    }
  }
}

customElements.define('ingredients-lookbook-icon', IngredientsLookbookIcon);
customElements.define('ingredient-card', IngredientCard); 